import { IAppState } from '../../redux';
import { IBetPosition } from '../../redux/reducers';

export function selectBetPosition(state: IAppState): IBetPosition | null {
  const {
    betPosition: { positionByService },
    publishTerms: { selectedServiceId },
  } = state;

  if (!selectedServiceId) {
    return null;
  }

  return positionByService[selectedServiceId] || null;
}
